import { CookieService } from 'ngx-cookie-service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UserApiService } from 'src/app/user-api.service';
import { ServiceInfo } from 'src/app/models/display/serviceInfo';
import { UserApi } from 'src/app/models/api_models/user';
import { AutorizationService } from 'src/app/api/autorization.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidenav-content-recharge',
  templateUrl: './sidenav-content-recharge.component.html',
  styleUrls: ['./sidenav-content-recharge.component.scss']
})
export class SidenavContentRechargeComponent implements OnInit {

  _servicesList : ServiceInfo[] = [];
  _currentUser : UserApi;
  isUserLoad : boolean = false;
  constructor(private cookieService: CookieService, private userApiService : UserApiService, private oauthService : AutorizationService, private router: Router) { }
  @Output() close = new EventEmitter<boolean>();


  disconnect() {
    localStorage.removeItem('token')
    localStorage.removeItem('token_offline')
    this.oauthService.logout();
    this.router.navigate(['/']).then(ok => {
      window.location.reload();
    });
  }

  CloseAction() {
    this.close.emit(true);
  }

  ngOnInit() {
    this.userApiService.getCurrentUserData().subscribe(
      response => {
        if (response != undefined) {
          this._currentUser = response;
          // console.log(this._currentUser);
          this.isUserLoad = true;
          this._servicesList = this._currentUser.getUserServices();
        }
      },
      error => {
        // console.log(error);
        
      }
    );
  }

}
